export class ProjectHealth {
  id: string;
  availabilityItemsOffTarget: number;
  availabilityItemsOnTarget: number;
  overallAvailabilityPercentage: number;
  countOfShippedItems: number;
  countOfDeliveredItems: number;

  constructor() {
    this.availabilityItemsOffTarget = 0;
    this.availabilityItemsOnTarget = 0;
    this.overallAvailabilityPercentage = -1;
  }
}

export class ProjectHealthInput {
  projectId: string;
  projectName: string;
  projectListFlag: boolean;

  constructor(projectId: string, projectName: string, projectListFlag: boolean) {
    this.projectId = projectId;
    this.projectName = projectName;
    this.projectListFlag = projectListFlag;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/project-health.ts